import React, { useState } from "react";
import { auth, db } from "../firebase";
import { useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc, collection, addDoc, updateDoc, increment, getDoc, query, where, getDocs } from "firebase/firestore";
import { ethers } from "ethers";
import { v4 as uuidv4 } from "uuid";
import "./SignupPage.css";

const SignupPage = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [loading, setLoading] = useState(false);

  // Generate referral code
  const generateReferralCode = (username) => {
    const random = uuidv4().substring(0, 6).toUpperCase();
    return username.substring(0, 3).toUpperCase() + random;
  };

  // Generate BEP-20 wallet
  const generateWallet = () => {
    const wallet = ethers.Wallet.createRandom();
    return { address: wallet.address, privateKey: wallet.privateKey };
  };

  // Save user to Firestore
  const saveUser = async (
    userId,
    username,
    email,
    mobile,
    referralCodeGenerated,
    referredBy,
    referrerId,
    levelBId,
    levelCId,
    wallet,
    giveBonus
  ) => {
    const baseAsset = giveBonus ? 0.0 : 0.0;

    const userData = {
      username,
      email,
      mobile,
      referralCode: referralCodeGenerated,
      referredBy: referredBy || null,
      referrerId: referrerId || null,
      levelBId: levelBId || null,
      levelCId: levelCId || null,
      asset: baseAsset,
      totalEarnings: 0.0,
      withdrawn: 0.0,
      isFirstDepositDone: false,
      createdAt: new Date(),
      bep20Address: wallet.address,
      bep20PrivateKey: wallet.privateKey,
      teamA: 0,
      teamB: 0,
      teamC: 0,
    };

    await setDoc(doc(db, "users", userId), userData);

    if (referrerId) await updateDoc(doc(db, "users", referrerId), { teamA: increment(1) });
    if (levelBId) await updateDoc(doc(db, "users", levelBId), { teamB: increment(1) });
    if (levelCId) await updateDoc(doc(db, "users", levelCId), { teamC: increment(1) });
  };

  // Handle Signup
  const handleSignup = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!username || !email || !mobile || !password) {
      alert("Please fill all required fields");
      setLoading(false);
      return;
    }
    if (password !== confirmPassword) {
      alert("Passwords do not match");
      setLoading(false);
      return;
    }

    try {
      let inviterDoc = null;
      let validReferral = false;

      if (referralCode) {
        const q = query(collection(db, "users"), where("referralCode", "==", referralCode));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          inviterDoc = querySnapshot.docs[0];
          validReferral = true;
        } else {
          alert("Invalid referral code");
          setLoading(false);
          return;
        }
      }

      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const userId = userCredential.user.uid;
      const generatedCode = generateReferralCode(username);
      const wallet = generateWallet();

      if (validReferral && inviterDoc) {
        const inviterId = inviterDoc.id;
        const levelBId = inviterDoc.get("referrerId");
        let levelCId = null;
        if (levelBId) {
          const bDoc = await getDoc(doc(db, "users", levelBId));
          if (bDoc.exists()) levelCId = bDoc.get("referrerId");
        }
        await saveUser(userId, username, email, mobile, generatedCode, referralCode, inviterId, levelBId, levelCId, wallet, true);
      } else {
        await saveUser(userId, username, email, mobile, generatedCode, null, null, null, null, wallet, false);
      }

      alert("Account created successfully!");
      navigate("/signin");
      // Optionally redirect to login page
    } catch (error) {
      alert("Signup failed: " + error.message);
    }
    setLoading(false);
  };

  return (
    <div className="signup-container">
      <form className="signup-form" onSubmit={handleSignup}>
        <h2>Create Account</h2>
        <input type="text" placeholder="Username" value={username} onChange={e => setUsername(e.target.value)} required />
        <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} required />
        <input type="text" placeholder="Mobile Number" value={mobile} onChange={e => setMobile(e.target.value)} required />
        <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required />
        <input type="password" placeholder="Confirm Password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required />
        <input type="text" placeholder="Referral Code (optional)" value={referralCode} onChange={e => setReferralCode(e.target.value)} />
        <button type="submit" disabled={loading}>{loading ? "Creating..." : "Sign Up"}</button>
        <p>Already have an account? <a href="/login">Back to Login</a></p>
      </form>
    </div>
  );
};

export default SignupPage;
